import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

// Get all notifications
const getAllNotifications = async () => {
  try {
    return await axios.get(`${API_URL}/notifications`);
  } catch (error) {
    throw error;
  }
};

// Get single notification
const getSingleNotification = async notificationId => {
  try {
    return await axios.get(`${API_URL}/notifications/${notificationId}`);
  } catch (error) {
    throw error;
  }
};

// Create notification
const createNotification = async data => {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}/notifications`,
      data
    });
  } catch (error) {
    throw error;
  }
};

// Update notification
const updateNotification = async (data, notificationId) => {
  try {
    return await axios({
      method: 'put',
      url: `${API_URL}/notifications/${notificationId}`,
      data
    });
  } catch (error) {
    throw error;
  }
};

// Delete notification
const deleteNotification = async notificationId => {
  try {
    return await axios.delete(`${API_URL}/notifications/${notificationId}`);
  } catch (error) {
    throw error;
  }
};

// Send notification
const sendNotification = async notificationId => {
  try {
    return await axios.post(`${API_URL}/notifications/${notificationId}/send`);
  } catch (error) {
    throw error;
  }
};

const notificationsApi = {};

notificationsApi.getAllNotifications = getAllNotifications;
notificationsApi.getSingleNotification = getSingleNotification;
notificationsApi.createNotification = createNotification;
notificationsApi.updateNotification = updateNotification;
notificationsApi.deleteNotification = deleteNotification;
notificationsApi.sendNotification = sendNotification;

export default notificationsApi;
